import { render } from "./App.vue?vue&type=template&id=61aa1522&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@/style/reset.scss?vue&type=style&index=0&lang=scss"
import "@/style/main.scss?vue&type=style&index=1&lang=scss"
import "@/style/fonts.scss?vue&type=style&index=2&lang=scss"
import "./App.vue?vue&type=style&index=3&id=61aa1522&lang=scss"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__